import { AttachmentProps } from '../entities/Advert';

export class AdvertAttachmentsService {
  static add(attachments: AttachmentProps[], newAttachment: AttachmentProps): AttachmentProps[] {
    const exists = attachments.some(a => a.url === newAttachment.url);
    if (exists) return attachments; // idempotent for now
    const next = [...attachments, newAttachment];
    if (next.length > 10) {
      throw new Error('advert-files-limit-exceeded');
    }
    return next.sort((a,b)=>a.position-b.position);
  }
  static remove(attachments: AttachmentProps[], key: string): AttachmentProps[] {
    return attachments.filter(a => (a.uuid ? a.uuid !== key : a.url !== key)).sort((a,b)=>a.position-b.position);
  }
  static reorder(attachments: AttachmentProps[]): AttachmentProps[] {
    return [...attachments].sort((a,b)=>a.position-b.position).map((a,i)=> ({...a, position: i}));
  }
  static images(attachments: AttachmentProps[]) {
    return attachments.filter(a => {
      const t = (a.type || '') as unknown as string;
      return t === 'image' || t.startsWith('image');
    });
  }
  static videos(attachments: AttachmentProps[]) {
    return attachments.filter(a => {
      const t = (a.type || '') as unknown as string;
      return t === 'video' || t.startsWith('video');
    });
  }
}
